import { render, staticRenderFns } from "./BVIndicator.vue?vue&type=template&id=717865a6&scoped=true&"
import script from "./BVIndicator.vue?vue&type=script&lang=js&"
export * from "./BVIndicator.vue?vue&type=script&lang=js&"
import style0 from "./BVIndicator.vue?vue&type=style&index=0&id=717865a6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "717865a6",
  null
  
)

export default component.exports